import { Trial, TrialProduct } from "../trials";
import styled from "onnit-ui/lib/themes/styled";
import React from "react";
import Box, { BoxProps } from "onnit-ui/lib/box/Box";
import { Img } from "onnit-ui/lib/image";
import Text from "onnit-ui/lib/text";
import Grid, { TwelveColumn } from "onnit-ui/lib/module/grid/12/Grid";
import { stripTags } from "../../../lib/utils";
import Product from "onnit-ui/lib/@types/interfaces/product/BuyBoxProduct";
import SingleProductBuyBox from "onnit-ui/lib/buybox/SingleProductBuyBox";
import AddToCartButton from "../../../components/common/AddToCartButton";
import { Disclaimer } from "./Disclaimers";


interface CustomAddToBagProps extends BoxProps {
    trialProduct: Product;
}

const CustomAddToBag: React.FC<CustomAddToBagProps> = ({ trialProduct, ...rest }) => {
    return (
        <>
            <SingleProductBuyBox
                {...rest}
                product={trialProduct}
                renderInStockView={(trialProduct: Product) => {
                    return (
                        <AddToCartButton
                            width={1}
                            buyBtnText="Get it Free"
                            buttonColor="black"
                            buttonTextColor="white"
                            configs={[
                                {
                                    product_id: trialProduct.id,
                                    quantity: 1,
                                    subscription_interval: null,
                                },
                            ]}
                        />
                    );
                }}
            />
        </>
    );
};

interface TrialBuyBoxProps extends BoxProps {
    activeTrialProduct: TrialProduct;
    activeTrial: Trial;
    fullProducts: Array<Product | null>;
    trialProducts: Array<Product | null>;
    imgUrl: string;
    imgParams: string;
    autoTrim?: boolean;
}

const TrialButtonContainer = styled(Box)<BoxProps>`    
    background-color: #161617;
    transition: box-shadow 200ms;
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-radius: 6px;
    line-height: 1.125;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
    text-align: center;
    border-color: "#4f4f4f";
    user-select: none;
    -webkit-appearance: none;
    -webkit-appearance: none !important;
    box-shadow: 2px 2px 0 0 rgba(0,0,0,.1875);    
`;


const TrialBuyBox: React.FC<TrialBuyBoxProps> = ({
    imgUrl,
    imgParams,
    fullProducts,
    trialProducts,
    activeTrial,
    activeTrialProduct,
    autoTrim = true,
    ...rest
}) => {
    const { productId, title, description, trialSlug } = activeTrial;
    const altTitle = stripTags(title);

    const newImgParams = autoTrim ? imgParams + "&trim=auto" : imgParams;
    const trialProduct = trialProducts?.filter(product => product?.id === activeTrial.trialProductId).shift();
    const fullProduct = fullProducts?.filter(product => product?.id === activeTrial.productId).shift();

    if (!fullProduct || !trialProduct) {
        return null;
    }

    const isTrialInStock = trialProduct.in_stock ?? false;
    const flexRowDirection = isTrialInStock ? "row" : "column";
    return (
        <Grid>
            <Box
                {...rest}
                gridColumn={["1 / -1", "1 / -1", "3 / span 8", "4 / span 7"]}
                justifyContent="center"
            >
                <TwelveColumn>
                    <Box gridColumn={["1 / -1", "1 / -1", "1 / span 4", "1 / span 4"]}>
                        <TrialButtonContainer p={4}>
                            <Img src={`${imgUrl}/authority/${productId}.png${newImgParams}`} alt={`${altTitle} product image.`} />
                        </TrialButtonContainer>
                    </Box>
                    <Box gridColumn={["1 / -1", "1 / -1", "5 / span 8", "5 / span 7"]} pl={[0, 4, 4, 6]} pt={[4, 2, 2, 4]}>

                        <Text as="h2" typeStyle="title03" pt={[2, 0]} textAlign={["center", "initial"]} fontWeight="bold" style={{ textTransform: "initial" }} dangerouslySetInnerHTML={{ __html: title }} />

                        <Text mt={[4, 2, 2, 4]} typeStyle="text04" fontWeight="bold" color="grays.4" dangerouslySetInnerHTML={{ __html: description }} />

                        <Box display="flex" flexDirection={["column", "column", flexRowDirection]} flex="0 0 100%" pt={[4, 4, 4, 6]} alignItems="center">
                            <Box display="flex" order={[1, 1, 2, `${isTrialInStock ? 2 : 1}`]} px={[0, 4, 4, 6]} textAlign="center">
                                <Text as="a" href={`/${trialSlug}`} typeStyle="caption01" target="_blank" fontWeight="heavy" textAlign="center">
                                    Learn More <span className="sr-only">about {title}.</span>
                                </Text>
                            </Box>
                            <Box display="flex" alignSelf={["start", "initial"]} width={["100%", "initial"]} flexDirection={["column", "initial"]} order={[2, 2, 1, `${isTrialInStock ? 1 : 2}`]}>
                                <CustomAddToBag trialProduct={trialProduct} pt={[6, 6, 2, 0]} />
                            </Box>
                        </Box>

                    </Box>
                </TwelveColumn>
                <TwelveColumn>
                    <Box gridColumn={["1 / -1", "1 / -1", "1 / span 11"]} pt={6}>
                        <Disclaimer fullProduct={fullProduct} activeTrialProduct={activeTrialProduct} />
                    </Box>
                </TwelveColumn>
            </Box>
        </Grid>
    );
};

export default TrialBuyBox;


